export default "__VITE_ASSET__C41iknO8__"